import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IFormActionTypes } from "../../action-types/form/IFormActionTypes";
import { IFormReducer } from "../../page-state-model/form/IFormReducer";
const iniState: IFormReducer = {
    status: ePageBaseStatus.is_not_initialization,
    forms: []
}
export const formReducer = (state: IFormReducer = iniState, action: IFormActionTypes): IFormReducer => {
    switch (action.type) {
        case "FORM_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "FORM_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                forms: action.payload
            }
        case "FORM_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                forms: []
            }
        case "FORM_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "FORM_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "FORM_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "FORM_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "FORM_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "FORM_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "FORM_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "FORM_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "FORM_LOCK_START":
            return {
                ...state,
                status: ePageBaseStatus.is_locking
            }
        case "FORM_LOCK_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "FORM_LOCK_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "FORM_UNLOCK_START":
            return {
                ...state,
                status: ePageBaseStatus.is_unlocking
            }
        case "FORM_UNLOCK_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "FORM_UNLOCK_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}